export const findJezyk = (Jezyki, lang) => Jezyki.find((e) => e.Jezyk === lang);

const contentSetup = (
  rowData,
  showRawHtml,
  textAreaInstance,
  htmlEditorInstance,
  smsTextRef
) => {
  if (rowData.WiadomoscTyp === 'Inne') {
    let newContent = showRawHtml
      ? textAreaInstance.option('text')
      : htmlEditorInstance.option('value');

    if (showRawHtml) {
      htmlEditorInstance.option('value', newContent);
      const textParsedByEditor = htmlEditorInstance.option('value');
      newContent = textParsedByEditor;
    }

    return newContent;
  }

  return smsTextRef.current.option('value');
};

export const prepareJezyki = (
  rowData,
  showRawHtml,
  textAreaInstance,
  htmlEditorInstance,
  smsTextRef,
  titleRef,
  selectBoxVal
) => {
  const Tresc = contentSetup(
    rowData,
    showRawHtml,
    textAreaInstance,
    htmlEditorInstance,
    smsTextRef
  );
  const Tytul = titleRef.current.option('value');

  const newJezyki = rowData.Jezyki.map((e) => ({ ...e }));

  const jezykIndex = newJezyki.findIndex((e) => e.Jezyk === selectBoxVal);

  const newJezyk = {
    Jezyk: selectBoxVal,
    Tresc,
    Tytul
  };

  if (jezykIndex !== -1) {
    newJezyki[jezykIndex] = newJezyk;
  } else {
    newJezyki.push(newJezyk);
  }

  return newJezyki;
};

export const dataHasChanged = (
  rowData,
  selectBoxVal,
  htmlEditorInstance,
  textAreaInstance,
  titleRef,
  smsTextRef,
  showRawHtml
) => {
  const jezyk = findJezyk(rowData.Jezyki, selectBoxVal);

  let trescChanged = false;
  let tytulChanged = false;

  const content = contentSetup(
    rowData,
    showRawHtml,
    textAreaInstance,
    htmlEditorInstance,
    smsTextRef
  );

  if (jezyk) {
    trescChanged = content !== jezyk.Tresc;
    tytulChanged = titleRef.current.option('value') !== jezyk.Tytul;
  } else {
    trescChanged = content !== '';
    tytulChanged = titleRef.current.option('value') !== '';
  }

  return tytulChanged || trescChanged;
};
